"use client";

import clsx from "clsx";
import { useEffect, useState } from "react";
import * as Flex from "@repo/ui/flex";
import { Logo } from "@/components/logo";
import * as Viewport from "@/components/viewport";
import styles from "./logo-overlay.module.css";

type BrandLogoProps = {
  activeFloor: "topshop" | "topman";
  showOverlayAnimation?: boolean;
};

export default function BrandLogo({ activeFloor }: BrandLogoProps) {
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.sessionStorage.removeItem("first");
    }

    setFadeOut(false);
    setHidden(false);

    const fadeTimeout = setTimeout(() => {
      setFadeOut(true);

      const hideTimeout = setTimeout(() => {
        setHidden(true);
      }, 1500);

      return () => clearTimeout(hideTimeout);
    }, 1000);

    return () => clearTimeout(fadeTimeout);
  }, []);

  return (
    <Flex.Container
      column
      justify="center"
      align="center"
      className={clsx(
        styles["landing-container"],
        styles[activeFloor],
        hidden && styles.hidden,
        fadeOut && styles.fadeOut,
      )}
    >
      <Viewport.Large>
        <Logo variant={activeFloor} height={72} />
      </Viewport.Large>
      <Viewport.Small>
        <Logo variant={activeFloor} height={36} />
      </Viewport.Small>
    </Flex.Container>
  );
}
